import { render, staticRenderFns } from "./RubricatorList.vue?vue&type=template&id=71629b4b&scoped=true"
import script from "./RubricatorList.vue?vue&type=script&lang=js"
export * from "./RubricatorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71629b4b",
  null
  
)

export default component.exports